/**
 * Logger utility para desarrollo
 * Solo muestra logs en modo desarrollo para mantener la consola limpia en producción
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]) => {
    console.warn(...args); // Warnings siempre se muestran
  },
  
  error: (...args: any[]) => {
    console.error(...args); // Errores siempre se muestran
  }
};

// Para PWA específicamente, usar niveles más apropiados
export const pwaLogger = {
  register: (...args: any[]) => {
    if (isDevelopment) {
      console.debug('PWA:', ...args);
    }
  },
  
  update: (...args: any[]) => {
    console.info('PWA:', ...args); // Updates son importantes
  },
  
  install: (...args: any[]) => {
    console.info('PWA:', ...args); // Instalación es importante
  },
  
  error: (...args: any[]) => {
    console.error('PWA:', ...args);
  },
  
  success: (...args: any[]) => {
    console.info('PWA:', ...args);
  }
};